import api from './api';

const contaService = {
  // Listar contas com paginação
  list: async (params = {}) => {
    try {
      const response = await api.get('/contas', { params });
      console.log('Params:', params);
      console.log('Contas listadas com sucesso:', response.data);
      return response.data;
    } catch (error) {
      console.error('Erro ao listar contas:', error);
      throw error;
    }
  },

  // Listar todas as contas ativas para selects
  getAll: async () => {
    try {
      const response = await api.get('/contas/all');
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar contas:', error);
      throw error;
    }
  },

  // Buscar conta por ID
  getById: async (id) => {
    try {
      const response = await api.get(`/contas/${id}`);
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar conta:', error);
      throw error;
    }
  },

  // Criar nova conta
  create: async (data) => {
    try {
      const response = await api.post('/contas', data);
      return response.data;
    } catch (error) {
      console.error('Erro ao criar conta:', error);
      throw error;
    }
  },

  // Atualizar conta
  update: async (id, data) => {
    try {
      const response = await api.put(`/contas/${id}`, data);
      return response.data;
    } catch (error) {
      console.error('Erro ao atualizar conta:', error);
      throw error;
    }
  },

  // Excluir conta
  delete: async (id) => {
    try {
      const response = await api.delete(`/contas/${id}`);
      return response.data;
    } catch (error) {
      console.error('Erro ao excluir conta:', error);
      throw error;
    }
  }
};

// Exports nomeados para compatibilidade com componentes existentes
export const getAll = contaService.getAll;
export const getAllContas = contaService.getAll;
export const getById = contaService.getById;
export const getContaById = contaService.getById;

export default contaService;
